module.exports = __webpack_public_path__ + "media/tutorialVideo.32df1966.mp4";